if (!customElements.get('w-cart')) {
  customElements.define(
    'w-cart',
    class WCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this._noteTimer = null;

        this.addEventListener('click', (e) => this._onClick(e));
        this.addEventListener('change', (e) => this._onChange(e));
        this.addEventListener('input', (e) => this._onInput(e));
        this.addEventListener('keydown', (e) => this._onKeydown(e));

        const form = this.querySelector('#w-cart-form');
        if (form) form.addEventListener('submit', (e) => this._onSubmit(e));

        this._syncHeaderCount();
      }

      /* ---------------- Events ---------------- */
      _onClick(e) {
        const qtyBtn = e.target.closest('[data-action]');
        if (qtyBtn && qtyBtn.closest('[data-quantity]')) {
          const row = qtyBtn.closest('[data-line]');
          const input = row.querySelector('.w-cart__qty-input');
          let qty = parseInt(input.value || '1', 10);
          qty = qtyBtn.dataset.action === 'increment' ? qty + 1 : qty - 1;
          this._changeLine(row.dataset.line, Math.max(0, qty));
          return;
        }

        const removeBtn = e.target.closest('[data-remove]');
        if (removeBtn) {
          const row = removeBtn.closest('[data-line]');
          this._changeLine(row.dataset.line, 0);
          return;
        }

        const upsellBtn = e.target.closest('[data-upsell-add]');
        if (upsellBtn) {
          const card = upsellBtn.closest('[data-upsell]');
          const select = card.querySelector('[data-upsell-variant]');
          const variantId = select ? select.value : upsellBtn.dataset.variantId;
          this._addItem(variantId);
          return;
        }

        const applyBtn = e.target.closest('[data-discount-apply]');
        if (applyBtn) {
          this._applyDiscount();
        }
      }

      _onChange(e) {
        if (e.target.matches('[data-terms-checkbox]')) {
          this._onTermsToggle(e.target.checked);
        }
      }

      _onInput(e) {
        if (e.target.matches('[data-cart-note]')) {
          clearTimeout(this._noteTimer);
          this._noteTimer = setTimeout(() => {
            this._post('/cart/update.js', { note: e.target.value });
          }, 600);
        }
      }

      _onKeydown(e) {
        if (e.key === 'Enter' && e.target.matches('[data-discount-input]')) {
          e.preventDefault();
          this._applyDiscount();
        }
      }

      _onSubmit(e) {
        const checkbox = this.querySelector('[data-terms-checkbox]');
        const error = this.querySelector('[data-terms-error]');
        if (checkbox && !checkbox.checked) {
          e.preventDefault();
          if (error) {
            error.hidden = false;
            error.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }

      /* ---------------- Terms ---------------- */
      _onTermsToggle(checked) {
        const button = this.querySelector('[data-checkout-button]');
        const hidden = this.querySelector('[data-terms-attr]');
        const error = this.querySelector('[data-terms-error]');

        const value = checked
          ? 'Yes — accepted on cart page at ' + new Date().toISOString() + ' (Terms of Service + Shipping Policy)'
          : '';

        if (hidden) hidden.value = value;
        if (button) {
          button.toggleAttribute('disabled', !checked);
        }
        if (checked && error) error.hidden = true;

        // Persist on the cart so the acceptance shows up on the order
        this._post('/cart/update.js', {
          attributes: { 'Terms & Shipping accepted': value },
        });
      }

      /* ---------------- Cart mutations ---------------- */
      async _changeLine(line, quantity) {
        this.classList.add('is-loading');
        try {
          const res = await this._post('/cart/change.js', {
            line: Number(line),
            quantity: quantity,
            sections: this.sectionId,
          });
          this._replaceSection(res);
        } catch (err) {
          window.location.reload();
        }
      }

      async _addItem(variantId) {
        if (!variantId) return;
        this.classList.add('is-loading');
        try {
          const res = await this._post('/cart/add.js', {
            id: Number(variantId),
            quantity: 1,
            sections: this.sectionId,
          });
          this._replaceSection(res);
        } catch (err) {
          window.location.reload();
        }
      }

      _applyDiscount() {
        const input = this.querySelector('[data-discount-input]');
        if (!input) return;
        const code = input.value.trim();
        if (!code) return;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
      }

      /* ---------------- Helpers ---------------- */
      async _post(url, body) {
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        if (!res.ok) throw new Error('Cart request failed: ' + res.status);
        return res.json();
      }

      _replaceSection(res) {
        const html = res && res.sections && res.sections[this.sectionId];
        if (!html) {
          window.location.reload();
          return;
        }
        const wrapper = document.getElementById('shopify-section-' + this.sectionId);
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.getElementById('shopify-section-' + this.sectionId);
        if (wrapper && fresh) {
          wrapper.replaceWith(fresh);
        } else {
          window.location.reload();
        }
      }

      _syncHeaderCount() {
        const count = parseInt(this.dataset.itemCount || '0', 10);
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = count;
          el.hidden = count === 0;
        });
      }
    }
  );
}